import { Icon } from 'components/Atoms/Icon/Icon';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import styles from '../Timeline.module.scss';

export function ProgressComplete() {
  const { t } = useTranslation();
  return (
    <div className={classNames(styles.progress, styles.complete)}>
      <Icon height={24} width={24} name="check" color="#fff" ariaLabel={t('icons.complete')} />
    </div>
  );
}
